import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import SiteLayout from './components/SiteLayout';
import HomePage from './pages/HomePage';
import {
  AiReceptionistPage,
  WebsiteChatbotPage,
  WebsitesPage,
  CompletePage,
  PricingPage,
  DemoPage,
} from './pages/ServicePages';
import { TradesHubPage, IndustryPage } from './pages/IndustryPages';
import { CustomSoftwarePage, CustomSoftwareServicePage } from './pages/CustomSoftwarePages';
import {
  AboutPage,
  ContactPage,
  PressPage,
  WorkPage,
  IntegrationsPage,
  HerveyBayPage,
  BulletChatPage,
  CaseStudiesPage,
} from './pages/CompanyPages';
import { GuidesHubPage, GuidePage } from './pages/GuidePages';
import CalculatorPage from './pages/CalculatorPage';
import { PrivacyPolicyPage, TermsPage, AiDataPolicyPage } from './pages/LegalPages';
import NotFoundPage from './pages/NotFoundPage';
import { BookCallProvider } from './components/BookCallModal';
import { siteConfig } from './siteConfig';

function App() {
  return (
    <BookCallProvider>
    <SiteLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/ai-receptionist" element={<AiReceptionistPage />} />
        <Route path="/website-chatbot" element={<WebsiteChatbotPage />} />
        <Route path="/websites" element={<WebsitesPage />} />
        <Route path="/complete" element={<CompletePage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/demo" element={siteConfig.demoPhone ? <DemoPage /> : <Navigate to="/" replace />} />

        <Route path="/industries/trades" element={<TradesHubPage />} />
        <Route path="/industries/:slug" element={<IndustryPage />} />

        <Route path="/custom-software" element={<CustomSoftwarePage />} />
        <Route path="/mvp-development" element={<CustomSoftwareServicePage slug="mvp-development" />} />
        <Route path="/saas-development" element={<CustomSoftwareServicePage slug="saas-development" />} />
        <Route path="/mobile-app-development" element={<CustomSoftwareServicePage slug="mobile-app-development" />} />
        <Route path="/ai-integration" element={<CustomSoftwareServicePage slug="ai-integration" />} />

        <Route path="/integrations" element={<IntegrationsPage />} />
        <Route path="/work" element={<WorkPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/press" element={<PressPage />} />
        <Route path="/hervey-bay" element={<HerveyBayPage />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />
        <Route path="/bullet-chat" element={<BulletChatPage />} />

        <Route path="/guides" element={<GuidesHubPage />} />
        <Route path="/guides/:slug" element={<GuidePage />} />
        <Route path="/tools/missed-call-calculator" element={<CalculatorPage />} />

        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-use" element={<TermsPage />} />
        <Route path="/ai-data-policy" element={<AiDataPolicyPage />} />

        <Route path="/website" element={<Navigate to="/websites" replace />} />
        <Route path="/herveybay" element={<Navigate to="/hervey-bay" replace />} />
        <Route path="/website-portfolio" element={<Navigate to="/work" replace />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </SiteLayout>
    </BookCallProvider>
  );
}

export default App;
